module.exports = __webpack_public_path__ + "img/card_dot.57c732db.svg";